import React, { HTMLAttributes, PropsWithChildren } from 'react';

import styles from '../styles.module.css';

export interface CardAppointmentContentProps
  extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  active?: boolean;
}

export const CardAppointmentContent: React.FC<CardAppointmentContentProps> = ({
  children,
  active = false,
  ...props
}) => {
  return (
    <main
      className={`${styles.cardContent} ${active ? styles.active : ''}`}
      {...props}
    >
      <hr />

      {children}
    </main>
  );
};
